import { render, staticRenderFns } from "./productCreate.vue?vue&type=template&id=5e0f9348&scoped=true"
import script from "./productCreate.vue?vue&type=script&lang=js"
export * from "./productCreate.vue?vue&type=script&lang=js"
import style0 from "./productCreate.vue?vue&type=style&index=0&id=5e0f9348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0f9348",
  null
  
)

export default component.exports